import { Variant, Variants } from "@kernel/react-ui-kit";
import { ErrorToast } from "./ErrorToast";

export class RemoteValidationErrorToast extends ErrorToast {
  public header(): string {
    return "Errore di validazione";
  }

  public bg(): Variant {
    return Variants.WARNING;
  }
}
